import * as types from './actionTypes';
import getAPIPath from '../../js/modules/api-location';
import { addNotification } from './notificationActions';

export function doIFollowSuccess(doIFollowArray) {
  return { type: types.DO_I_FOLLOW_SUCCESS, doIFollowArray };
}

export function followToggleSuccess(userId, followBool) {
  return { type: types.FOLLOW_TOGGLE_SUCCESS, userId, followBool };
}

export function doIFollow(userIds) {
  // This API accepts an array of id's so if we pass multiple we need to format it
  let getParams = ``;
  function constructFollowGetParam(item) {
    getParams = `${getParams}user_id=${item}&`;
  }
  userIds.forEach(constructFollowGetParam);

  return function(dispatch) {
    return fetch(`${getAPIPath}queryapi/do-i-follow?${getParams}`, {
      method: `GET`,
      credentials: `include`,
      headers: {
        Accept: `application/json`,
      },
    })
    .then((response) => {
      if (response.status === 200) {
        response.json().then((res) => {
          dispatch(doIFollowSuccess(res.data));
        });
      }
    }).catch((error) => {
      throw (error);
    });
  };
}

export function unfollowUser(userId) {
  return function(dispatch) {
    // Optmistic UI pattern
    dispatch(followToggleSuccess(userId, false));

    return fetch(`${getAPIPath}queryapi/user/follow/${userId}`, {
      method: `DELETE`,
      credentials: `include`,
      headers: {
        Accept: `application/json`,
      },
    })
    .then((response) => {
      if (response.status !== 200) {
        dispatch(followToggleSuccess(userId, true));
        dispatch(addNotification({
          message: `There was a problem unfollowing this user. Please contact us if the problem persists.`,
          level: `error`,
          autoDismiss: 0,
        }));
      }
    }).catch((error) => {
      throw (error);
    });
  };
}

export function followUser(userId) {
  const item = {};
  item.follow_user_id = userId;

  return function(dispatch) {
    // Optmistic UI pattern
    dispatch(followToggleSuccess(userId, true));

    return fetch(`${getAPIPath}queryapi/user/follow`, {
      method: `POST`,
      body: JSON.stringify(item),
      credentials: `include`,
      headers: {
        Accept: `application/json`,
      },
    })
    .then((response) => {
      if (response.status !== 200) {
        dispatch(followToggleSuccess(userId, false));
        dispatch(addNotification({
          message: `There was a problem following this user. Please contact us if the problem persists.`,
          level: `error`,
          autoDismiss: 0,
        }));
      }
    }).catch((error) => {
      throw (error);
    });
  };
}



// WEBPACK FOOTER //
// ./library/app/actions/followActions.js